module.exports = __webpack_public_path__ + "img/2.0be80c04.png";